module.exports = __webpack_public_path__ + "img/camel-m.475fba4.webp";